import { useEffect, useState } from 'react';
import { isNativeApp } from '../services/platform-service.js';
import { HERO_IMAGE, prefetchHeroes } from '../services/hero-image.js';

// Cold start 오버레이. 네이티브 iOS 는 같은 톤의 정적 LaunchScreen 을 먼저
// 보여주고, Capacitor 가 SplashScreen.hide() 를 부르면 이 컴포넌트가 같은
// 캔버스를 이어받는다.
//
// 2026-08 리프레시: 예전 시퀀스(베이지 배경 + 글자 하나씩 등장 + 테라코타
// 라인 draw + "ATELIER · AI" 태그라인, ~3.2s)를 걷어냈다. 이제 Welcome 과
// 같은 인테리어 사진 위에 워드마크만 올라오고 짧게 끝난다 (~2.0s) —
// 스플래시와 로그인이 같은 장면이라 진입이 끊기지 않고, 3초 넘게 붙잡던
// 것도 줄였다.
export function JsSplash() {
  // 정적으로 구운 랜딩이 이미 보이고 있으면(scripts/prerender-landing.mjs 의 head 스크립트가
  // window.__lpPrerendered 를 켠다) 스플래시를 건너뛴다 — 다 그려진 페이지를 2초 덮게 된다.
  const [skip] = useState(() => typeof window !== 'undefined' && window.__lpPrerendered === true);
  const [phase, setPhase] = useState(skip ? 'done' : 'enter');

  useEffect(() => {
    // 네이티브 스플래시를 내려 이 컴포넌트가 같은 화면을 이어받게 한다.
    // @vite-ignore — @capacitor/splash-screen 이 없는 웹 빌드에서 vite 가
    // 모듈을 해석하려다 실패하지 않도록.
    if (isNativeApp()) {
      import(/* @vite-ignore */ '@capacitor/splash-screen')
        .then(({ SplashScreen }) => SplashScreen.hide({ fadeOutDuration: 200 }).catch(() => {}))
        .catch(() => {});
    }

    // 나머지 히어로는 유휴 시간에 미리 받아 둔다 (다음 실행에서 즉시 표시).
    prefetchHeroes();

    if (skip) return undefined;
    const exitTimer = setTimeout(() => setPhase('exit'), 1600);
    const doneTimer = setTimeout(() => setPhase('done'), 2000);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, [skip]);

  if (phase === 'done') return null;

  return (
    <div className={`js-splash ${phase === 'exit' ? 'js-splash-exit' : ''}`} aria-hidden="true">
      <img className="js-splash-bg" src={HERO_IMAGE} alt="" />
      <div className="js-splash-veil" />
      <span className="js-splash-wordmark">archelier</span>
    </div>
  );
}
